import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-ivory" data-testid="site-footer">
      <div className="max-w-[1320px] mx-auto px-6 md:px-12">
        <hr className="hairline" />
        <div className="py-14 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div>
            <p className="eyebrow eyebrow--stone">Contact</p>
            <p className="mt-4 font-sans text-[0.95rem] text-temple leading-relaxed">
              info@shivamurtihealingarts.com
            </p>
            <p className="mt-1 font-sans text-[0.95rem] text-stone leading-relaxed">
              Vancouver · Worldwide via video
            </p>
          </div>

          <div>
            <p className="eyebrow eyebrow--stone">Pages</p>
            <ul className="mt-4 space-y-2 font-sans text-[0.95rem]">
              <li><Link to="/receive" className="hover:text-gold transition-colors" data-testid="footer-link-receive">Receive</Link></li>
              <li><Link to="/become" className="hover:text-gold transition-colors" data-testid="footer-link-become">Become</Link></li>
              <li><Link to="/lineage" className="hover:text-gold transition-colors" data-testid="footer-link-lineage">Lineage</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="flex md:justify-end">
            <img
              src="/assets/shiva-murti-logo.png"
              alt="Shiva Murti — Sacred Healing Arts"
              className="block w-40 md:w-48 h-auto"
              data-testid="footer-logo"
            />
          </div>
        </div>

        <hr className="hairline" />
        <div className="py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
          <p className="caption">© Shiva Murti — Sacred Healing Arts</p>
          <p className="caption">A living Balinese lineage</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
